export default __webpack_public_path__ + "static/media/abstract3.42207e30.jpg";